import { post } from '../utility';

export const add = ({
	terminalId,
	supplierForTerminalId,
	productType,
	periodYear,
	periodMonth,
	adjustmentGallons,
	reason,
	callback,
}) => {
	post({
		method: 'inventoryAdjustment.add',
		params: {
			terminalId,
			supplierForTerminalId,
			productType,
			periodYear,
			periodMonth,
			adjustmentGallons,
			reason,
		},
		callback,
	});
};

export const remove = ({ inventoryAdjustmentId, callback }) => {
	post({
		method: 'inventoryAdjustment.remove',
		params: { inventoryAdjustmentId },
		callback,
	});
};
